import {filter as f,map as m,compose as C,converge,identity,sum,concat,mergeDeepWith, 
    reduce, length, values, curry, contains, divide, of, pick, reject, __, uniq, append,
    tap,defaultTo,
    addIndex,
    replace,
    trim,
    head,
    type,
    min
} from 'ramda'; 
import {r,abs} from "./math"
import { stdev, the_mean } from './mean';

const rounded_percents = curry((sum,list) => m(x => r(3,x/sum),list));
const percents = m(converge(rounded_percents,[sum,identity]))
const omit_empty = reject(contains(NaN));
const prepare = selected => C(
    omit_empty, 
    percents,
    reduce(mergeDeepWith(concat),{}),
    m(C(m(of),pick(selected))),
)

const array_of_sums = selected =>  C(
    reduce((acc,xs) => xs.map((x,n) => x+(acc[n] || 0)),[]),
    values,
    pick(selected))
const count = selected => C(length,values,pick(selected ))
const averages = (len,xs) => m(divide(__,len),xs);
const diff = avgs => xs => xs.map((x,n) => x-avgs[n]);
const diffs = fn => (selected,country,data) =>  C(fn,
        converge(m,[
            converge(C(diff,averages),[
                C(count(selected)),
                C(array_of_sums(selected))]),
            identity]),
        prepare(uniq(append(country,selected))),
        f(x => x),
        m(x => {return x || {}})
    )(data)

export const explain_dist = ({data,label,item,item_labels,diff,country,comparison,scale}) => {
    const selected_data = C(m(m(x=> x*100)),pick(__,data),uniq,append(country))(comparison);
    const value = selected_data[country];
    const word = scale[min(4,Math.floor(diff/0.2))];
    const shorten = [
        ["All students: ", ""], 
        ["national currency adjusted to", ""],
        ["in national currency adjusted to PPS in the EU",""]
    ];
    const labels = item_labels ? m(C(...m(x => replace(...x), shorten)),item_labels) : [];

    const compare_sentence = (x,capitalize) => x === 0 ? `${capitalize ? "T" : "t"}here was no difference in answer` :
         `${Math.abs(r(1, x))}% ${x > 0 ? "more" : "less"} people answered`;

    return (value && labels) ? (
        <>
            <p>
                To question "{label[0]}" in selected country <span style={item_labels?.[0] === item ? {fontWeight: 700} : {}}>
                    {compare_sentence(value[0])} "{trim(labels?.[0] || "")}"
                </span> compared to the comparison group average.
                {(item_labels || []).slice(1).map((x, n, xs) => (
                    <span key={n} style={x === item ? {fontWeight: 700} : {}}>
                        {(n === xs.length - 1 && label.length === 1) ? "and " : ""}{
                        label.length > 1 ? "To question "+ label[n+1] : ""} {
                        compare_sentence(value[n+1],!n)} "{labels[n + 1]}"{
                        n === xs.length - 2 ? " " : (n === xs.length - 1 || label.length > 1) ? "." : ","}
                    </span>
                ))}
            </p>
            <p>
                Cumulative difference of all answers was {r(1, diff * 100)}%, which can be interpreted as {
                diff <= 0.2 ? "not different from group average ("+(Math.floor(diff / 0.2) + 1)+"/5)." : ""} 
                {diff <= 0.2 ? "" : word+" ("+(min(5,Math.floor(diff / 0.2)+1))+"/5) from comparison group average."}
            </p>
        </>
    ) : null;
}


    
const round_summed_abs = m(C(r(2),sum,m(abs)));
const round_values  = m(m(r(2)));

export const summed_diffs = diffs(round_summed_abs);
export const just_diffs = diffs(round_values);